import * as React from 'react';

import styles from './ConversationExcerptDivider.module.scss';

function ConversationExcerptDivider() {
  return <div className={`${styles.divider} text-center py-4`}>—— ◆ ——</div>;
}

export default ConversationExcerptDivider;
